import { render, staticRenderFns } from "./reporting.vue?vue&type=template&id=348166b2&scoped=true&"
import script from "./reporting.vue?vue&type=script&lang=js&"
export * from "./reporting.vue?vue&type=script&lang=js&"
import style0 from "./reporting.vue?vue&type=style&index=0&id=348166b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348166b2",
  null
  
)

export default component.exports